var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect8, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveDailyJournaling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 158,
    viewBox: "0 0 271 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.282 128.91C91.2108 133.484 73.664 123.354 69.0899 106.283C64.5158 89.2117 74.6464 71.6649 91.7173 67.0908C108.788 62.5167 126.335 72.6473 130.909 89.7182C135.483 106.789 125.353 124.336 108.282 128.91Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.658 105.793L116.032 97.3047L108.648 110.095L117.812 108.991L119.658 105.793Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.452 82.5416C88.0973 81.1821 85.0864 81.9889 83.7269 84.3436L81.2654 88.6071C79.9059 90.9618 80.7127 93.9727 83.0674 95.3321L85.1991 96.5629L92.5837 83.7724L90.452 82.5416Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 27.0769,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 92.584 83.7695)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.867 108.624L119.658 105.794L117.812 108.992L120.867 108.624Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.38462,
    height: 1.23077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 119.516 103.586)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 1.23077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 92.0479 83.46)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.7692,
    height: 1.23077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 114.965 96.6943)",
    fill: "#D89FEE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: -1.22474,
    width: 66,
    height: 66,
    rx: 33,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 124.334 58.5838)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.659 134.765C159.785 136.609 171.921 127.464 173.766 114.338C175.611 101.213 166.466 89.0765 153.34 87.2318C140.214 85.387 128.078 94.5322 126.233 107.658C124.388 120.784 133.534 132.92 146.659 134.765Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.078 118.597L138.001 111.946L144.667 120.793L137.744 120.808L136.078 118.597Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.694 98.6176C157.322 97.3904 159.637 97.7157 160.865 99.3443L163.087 102.293C164.314 103.922 163.989 106.237 162.36 107.464L160.886 108.575L154.219 99.7286L155.694 98.6176Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.219,
    y: 99.7266,
    width: 11.0769,
    height: 20.3077,
    transform: "rotate(53 154.219 99.7266)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.436 120.814L136.077 118.597L137.744 120.808L135.436 120.814Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.982,
    y: 116.94,
    width: 5.53846,
    height: 0.923077,
    transform: "rotate(53 135.982 116.94)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.59,
    y: 99.4473,
    width: 11.0769,
    height: 0.923077,
    transform: "rotate(53 154.59 99.4473)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.74,
    y: 111.394,
    width: 11.0769,
    height: 0.923077,
    transform: "rotate(53 138.74 111.394)",
    fill: "#D89FEE"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128.722,
    y: 82.7622,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 128.722 82.7622)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.212 103.183C175.409 106.613 162.249 99.0152 158.818 86.212C155.387 73.4088 162.985 60.2487 175.788 56.8181C188.592 53.3875 201.752 60.9855 205.182 73.7887C208.613 86.5919 201.015 99.7519 188.212 103.183Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.744 85.8451L194.024 79.4785L188.486 89.0714L195.359 88.2433L196.744 85.8451Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.84 68.4067C173.074 67.3871 170.816 67.9922 169.796 69.7582L167.95 72.9558C166.931 74.7218 167.536 76.98 169.302 77.9996L170.901 78.9227L176.439 69.3298L174.84 68.4067Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 20.3077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 176.438 69.3271)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.651 87.9679L196.744 85.8457L195.36 88.2439L197.651 87.9679Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.53846,
    height: 0.923077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 196.637 84.1895)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 0.923077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 176.036 69.0957)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 0.923077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 193.225 79.0205)",
    fill: "#D89FEE"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: -1.22474,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 200.678 50.3817)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.753 83.0458C147.69 87.0482 163.044 78.1839 167.046 63.2468C171.048 48.3098 162.184 32.9563 147.247 28.954C132.31 24.9516 116.957 33.8159 112.954 48.753C108.952 63.69 117.816 79.0434 132.753 83.0458Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.799 62.8183L125.972 55.3906L132.433 66.5823L124.414 65.6162L122.799 62.8183Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.353 42.4742C150.414 41.2846 153.048 41.9905 154.238 44.0509L156.392 47.7815C157.581 49.8418 156.875 52.4763 154.815 53.6659L152.95 54.7428L146.488 43.5511L148.353 42.4742Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.489,
    y: 43.5488,
    width: 12.9231,
    height: 23.6923,
    transform: "rotate(60 146.489 43.5488)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74 65.2962L122.798 62.8203L124.413 65.6182L121.74 65.2962Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.924,
    y: 60.8867,
    width: 6.46154,
    height: 1.07692,
    transform: "rotate(60 122.924 60.8867)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.958,
    y: 43.2783,
    width: 12.9231,
    height: 1.07692,
    transform: "rotate(60 146.958 43.2783)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.906,
    y: 54.8574,
    width: 12.9231,
    height: 1.07692,
    transform: "rotate(60 126.906 54.8574)",
    fill: "#D89FEE"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 119.494,
    y: 20.4823,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(15 119.494 20.4823)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.176 56.3191C196.845 53.4602 203.177 42.4935 200.318 31.8242C197.459 21.1548 186.493 14.8232 175.823 17.682C165.154 20.5409 158.822 31.5076 161.681 42.1769C164.54 52.8462 175.507 59.1779 186.176 56.3191Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.795 47.3616L172.104 41.6338L180.099 46.2492L174.793 48.5154L172.795 47.3616Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.337 25.651C182.186 24.1794 184.068 23.6751 185.54 24.5248L188.204 26.0633C189.676 26.9129 190.18 28.7947 189.331 30.2664L188.561 31.5988L180.567 26.9834L181.337 25.651Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.567,
    y: 26.9814,
    width: 9.23077,
    height: 16.9231,
    transform: "rotate(30 180.567 26.9814)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.024 49.2726L172.794 47.3633L174.792 48.5171L173.024 49.2726Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.182,
    y: 46.1221,
    width: 4.61539,
    height: 0.769231,
    transform: "rotate(30 172.182 46.1221)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.761,
    y: 26.6465,
    width: 9.23077,
    height: 0.769231,
    transform: "rotate(30 180.761 26.6465)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.492,
    y: 40.9707,
    width: 9.23077,
    height: 0.769231,
    transform: "rotate(30 172.492 40.9707)",
    fill: "#D89FEE"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 155.28,
    y: 22.1513,
    width: 42,
    height: 42,
    rx: 21,
    transform: "rotate(-15 155.28 22.1513)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.212 51.1825C95.4086 54.6131 82.2485 47.0152 78.8179 34.212C75.3873 21.4088 82.9853 8.24871 95.7885 4.8181C108.592 1.3875 121.752 8.98548 125.182 21.7887C128.613 34.5919 121.015 47.7519 108.212 51.1825Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.743 33.8422L114.023 27.4756L108.485 37.0685L115.358 36.2404L116.743 33.8422Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8402 16.4096C93.0742 15.39 90.816 15.9951 89.7964 17.7611L87.9503 20.9587C86.9307 22.7247 87.5357 24.9829 89.3018 26.0025L90.9006 26.9256L96.439 17.3327L94.8402 16.4096Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 20.3077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 96.4375 17.3311)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.651 35.9708L116.744 33.8486L115.36 36.2469L117.651 35.9708Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.53846,
    height: 0.923077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 116.636 32.1865)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 0.923077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 96.0361 17.0986)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.0769,
    height: 0.923077,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 113.225 27.0205)",
    fill: "#D89FEE"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: -1.22474,
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 120.678 -1.6183)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_11322_9732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7882 80.1825C73.5914 83.6131 86.7515 76.0152 90.1821 63.212C93.6127 50.4088 86.0147 37.2487 73.2115 33.8181C60.4083 30.3875 47.2482 37.9855 43.8176 50.7887C40.387 63.5919 47.985 76.7519 60.7882 80.1825Z",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.257 62.8422L54.9766 56.4756L60.515 66.0685L53.6417 65.2404L52.257 62.8422Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1598 45.4096C75.9258 44.39 78.184 44.9951 79.2036 46.7611L81.0497 49.9587C82.0693 51.7247 81.4643 53.9829 79.6982 55.0025L78.0994 55.9256L72.561 46.3327L74.1598 45.4096Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5625,
    y: 46.3311,
    width: 11.0769,
    height: 20.3077,
    transform: "rotate(60 72.5625 46.3311)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3494 64.9708L52.2559 62.8486L53.6405 65.2469L51.3494 64.9708Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.3643,
    y: 61.1865,
    width: 5.53846,
    height: 0.923077,
    transform: "rotate(60 52.3643 61.1865)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9639,
    y: 46.0986,
    width: 11.0769,
    height: 0.923077,
    transform: "rotate(60 72.9639 46.0986)",
    fill: "#D89FEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.7754,
    y: 56.0205,
    width: 11.0769,
    height: 0.923077,
    transform: "rotate(60 55.7754 56.0205)",
    fill: "#D89FEE"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3222,
    y: 26.3817,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(15 49.3222 26.3817)",
    stroke: "#F5E5FB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 100C57 98.8954 57.8954 98 59 98H79.2654C80.2607 98 81.1046 98.7319 81.2453 99.7172L84.7547 124.283C84.8954 125.268 85.7393 126 86.7346 126H187.265C188.261 126 189.105 125.268 189.245 124.283L192.755 99.7172C192.895 98.7319 193.739 98 194.735 98H215C216.105 98 217 98.8954 217 100V126V152C217 153.105 216.105 154 215 154H185H89H59C57.8954 154 57 153.105 57 152V126V100Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 31.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 135.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 132.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 12.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 65.5,
    r: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 29 158)",
    fill: "#24284E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 86L245 89.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 37.5L237 33",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19L35.5 25",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 92L32.5 87.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 122.627 58.8086)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.573,
    y: 83.8916,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 129.573 83.8916)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 198.971 50.6064)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.201,
    y: 21.707,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(15 120.201 21.707)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.505,
    y: 22.8584,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-15 156.505 22.8584)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "matrix(-0.965926 0.258819 0.258819 0.965926 118.971 -1.39355)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_11322_9732"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.0293,
    y: 27.6064,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(15 50.0293 27.6064)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveDailyJournaling);
export default __webpack_public_path__ + "static/media/collective-daily-journaling.8a61d5252bea9d241e44625222b6de07.svg";
export { ForwardRef as ReactComponent };